export const themeConstants = [
  {
    themeName: "default",
    secondaryColor: "#fffbe6",
    primaryColor: "#ffb30e",
    tertiaryColor: "#fff1b0",
  },
  {
    themeName: "brown",
    secondaryColor: "#FFFAF0",
    primaryColor: "#6F4E37",
    tertiaryColor: "#a39f99",
  },
  {
    themeName: "magenta",
    secondaryColor: "#CEB0C0",
    primaryColor: "#421C40",
    tertiaryColor: "#F4E5ED",
  },
  {
    themeName: "skyblue",
    secondaryColor: "#C7E5F4",
    primaryColor: "#00AEFF",
    tertiaryColor: "#E1EDF4",
  },
  {
    themeName: "orange",
    secondaryColor: "#fff7e6",
    primaryColor: "#fa8c16",
    tertiaryColor: "#ffe7ba",
  },
  {
    themeName: "green",
    secondaryColor: "#f6ffed",
    primaryColor: "#52c41a",
    tertiaryColor: "#d9f7be",
  },
  {
    themeName: "mint",
    secondaryColor: "#e6f5ed",
    primaryColor: "#3eb489",
    tertiaryColor: "#dae8e1",
  },
  {
    themeName: "viridian",
    secondaryColor: "#BBF1A9",
    primaryColor: "#3B6930",
    tertiaryColor: "#A0D490",
  },
  {
    themeName: "lime",
    secondaryColor: "#fcffe6",
    primaryColor: "#a0d911",
    tertiaryColor: "#f4ffb8",
  },
  {
    themeName: "blue",
    secondaryColor: "#e6f4ff",
    primaryColor: "#001529",
    tertiaryColor: "#bae0ff",
  },
  {
    themeName: "red",
    secondaryColor: "#fff1f0",
    primaryColor: "#f5222d",
    tertiaryColor: "#ffccc7",
  },
  {
    themeName: "pink",
    secondaryColor: "#ffd6e7",
    primaryColor: "#eb2f96",
    tertiaryColor: "#fff0f6",
  },
  {
    themeName: "purple",
    secondaryColor: "#efdbff",
    primaryColor: "#722ed1",
    tertiaryColor: "#f9f0ff",
  },
  {
    themeName: "slate",
    secondaryColor: "#A7B2B8",
    primaryColor: "#2F4858",
    tertiaryColor: "#F2F2F2",
  },
  {
    themeName: "navy",
    secondaryColor: "#B3C6E7",
    primaryColor: "#1E3A8A",
    tertiaryColor: "#F0F4FF",
  },
  {
    themeName: "teal",
    secondaryColor: "#B8E6E6",
    primaryColor: "#008B8B",
    tertiaryColor: "#E6F7F7",
  },
  {
    themeName: "lavender",
    secondaryColor: "#E6E6FA",
    primaryColor: "#9370DB",
    tertiaryColor: "#F5F5FF",
  },
  {
    themeName: "coral",
    secondaryColor: "#FFE4E1",
    primaryColor: "#FF7F50",
    tertiaryColor: "#FFB6C1",
  },
  {
    themeName: "forest",
    secondaryColor: "#E8F5E8",
    primaryColor: "#228B22",
    tertiaryColor: "#C8E6C9",
  },
  {
    themeName: "sunset",
    secondaryColor: "#FFF8DC",
    primaryColor: "#FF6347",
    tertiaryColor: "#FFE4B5",
  },
];

export const avatarColors: Record<string, string> = {
  A: "#FF6F61", // coral red
  B: "#6B5B95", // muted purple
  C: "#88B04B", // olive green
  D: "#F7CAC9", // soft rose
  E: "#92A8D1", // steel blue
  F: "#955251", // warm maroon
  G: "#B565A7", // orchid purple
  H: "#009B77", // teal green
  I: "#DD4124", // cinnabar red
  J: "#D65076", // raspberry pink
  K: "#45B8AC", // turquoise green
  L: "#EFC050", // mustard yellow
  M: "#5B5EA6", // indigo blue
  N: "#9B2335", // crimson
  O: "#BC243C", // ruby red
  P: "#C3447A", // magenta rose
  Q: "#98B4D4", // slate blue
  R: "#E15D44", // persimmon
  S: "#7FCDCD", // aqua cyan
  T: "#006E51", // jade green
  U: "#D2691E", // copper brown
  V: "#4B0082", // indigo
  W: "#FF7F50", // coral
  X: "#3F51B5", // cobalt blue
  Y: "#8BC34A", // lime green
  Z: "#FF9800", // amber orange
};

export const currencySymbols = {
  USD: "$",      // US Dollar
  EUR: "€",      // Euro
  GBP: "£",      // British Pound
  INR: "₹",      // Indian Rupee
  JPY: "¥",      // Japanese Yen
  CNY: "¥",      // Chinese Yuan
  RUB: "₽",      // Russian Ruble
  KRW: "₩",      // South Korean Won
  AUD: "A$",     // Australian Dollar
  CAD: "C$",     // Canadian Dollar
  CHF: "CHF",    // Swiss Franc
  SGD: "S$",     // Singapore Dollar
  HKD: "HK$",    // Hong Kong Dollar
  NZD: "NZ$",    // New Zealand Dollar
  AED: "د.إ",    // UAE Dirham
  SAR: "﷼",      // Saudi Riyal
  ZAR: "R",      // South African Rand
  BRL: "R$",     // Brazilian Real
  MXN: "Mex$",   // Mexican Peso
};
